/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdatePersonRolesViewModel } from "../types/UpdatePersonRolesViewModel.ts";

export const updatePersonRolesViewModelSchema = z.object({
  isStudent: z
    .boolean()
    .describe("Define se a pessoa possui vínculo como aluno. Opcional.")
    .nullish(),
  isMonitor: z
    .boolean()
    .describe("Define se a pessoa possui vínculo como monitor. Opcional.")
    .nullish(),
  isEmployee: z
    .boolean()
    .describe("Define se a pessoa possui vínculo como funcionário. Opcional.")
    .nullish(),
  isTeachingStaff: z
    .boolean()
    .describe("Define se a pessoa faz parte do corpo docente. Opcional.")
    .nullish(),
  isMonitorTCC: z
    .boolean()
    .describe(
      "Define se a pessoa possui vínculo como monitor de TCC. Opcional.",
    )
    .nullish(),
  isStreamer: z
    .boolean()
    .describe(
      "Define se a pessoa possui vínculo como streamer de conteúdo ao vivo. Opcional.",
    )
    .nullish(),
  isFreelancerMBX: z
    .boolean()
    .describe(
      "Define se a pessoa possui vínculo como freelancer MBX. Opcional.",
    )
    .nullish(),
  isFreelancerEnglish: z
    .boolean()
    .describe(
      "Define se a pessoa possui vínculo como freelancer de inglês. Opcional.",
    )
    .nullish(),
  isMonographCoordinator: z
    .boolean()
    .describe(
      "Define se a pessoa possui vínculo como coordenador de monografia. Opcional.",
    )
    .nullish(),
  isMonographAdvisor: z
    .boolean()
    .describe(
      "Define se a pessoa possui vínculo como orientador de monografia. Opcional.",
    )
    .nullish(),
  isMonographOperational: z
    .boolean()
    .describe(
      "Define se a pessoa possui vínculo operacional no processo de monografia. Opcional.",
    )
    .nullish(),
  isBoardMember: z
    .boolean()
    .describe(
      "Define se a pessoa faz parte do conselho ou diretoria. Opcional.",
    )
    .nullish(),
  isReviewer: z
    .boolean()
    .describe(
      "Define se a pessoa possui vínculo como revisor de conteúdo. Opcional.",
    )
    .nullish(),
  isExamItemCreator: z
    .boolean()
    .describe(
      "Define se a pessoa possui vínculo como criador de itens de prova. Opcional.",
    )
    .nullish(),
  isExamItemApprover: z
    .boolean()
    .describe(
      "Define se a pessoa possui vínculo como aprovador de itens de prova. Opcional.",
    )
    .nullish(),
  seeOnlyOwnExamItem: z
    .boolean()
    .describe(
      "Define se a pessoa pode visualizar apenas os itens de prova criados por ela mesma. Opcional.",
    )
    .nullish(),
  isSeller: z
    .boolean()
    .describe("Define se a pessoa possui vínculo como vendedor. Opcional.")
    .nullish(),
  isSellerManager: z
    .boolean()
    .describe(
      "Define se a pessoa possui vínculo como gerente de vendas. Opcional.",
    )
    .nullish(),
  isSocialAssistant: z
    .boolean()
    .describe(
      "Define se a pessoa possui vínculo como assistente social. Opcional.",
    )
    .nullish(),
  isVisitor: z
    .boolean()
    .describe("Define se a pessoa possui vínculo como visitante. Opcional.")
    .nullish(),
  isClassCoordinator: z
    .boolean()
    .describe(
      "Define se a pessoa possui vínculo como coordenador de turma. Opcional.",
    )
    .nullish(),
  isPolo: z
    .boolean()
    .describe(
      "Define se a pessoa possui vínculo como polo educacional. Opcional.",
    )
    .nullish(),
  isTest: z
    .boolean()
    .describe("Define se a pessoa é um cadastro de teste. Opcional.")
    .nullish(),
  monographActive: z
    .boolean()
    .describe(
      "Define se o vínculo de monografia da pessoa está ativo. Opcional.",
    )
    .nullish(),
}) as unknown as ToZod<UpdatePersonRolesViewModel>;
